import { TraitRegistryCategory } from '../../../registry/trait/TraitRegistryCategory';
import { TraitsWordTask } from '../../../questiontype/KnowAWord/registry/TraitsWordTask';
export class RareTraits extends TraitRegistryCategory {
    label = 'Rare';
    constructor(parent) {
        super(parent);
    }
    c_w = new TraitsWordTask(this);
}
